/// <amd-module name="VSS/Diagnostics/DiagnosticDataService" />
import { IVssPageContext, IVssService, ServiceOptions, Services, VssService } from "VSS/Platform/Context";
import { IDiagnosticData, IVssPageService } from "VSS/Platform/Page";

/**
 * This service will manage diagnostic data for requests.  You can retrieve just the data for the current request or
 * fetch all diagnostic data accumulated across fps requests.
 */
export interface IDiagnosticDataService extends IVssService {
    /**
     * Returns diagnostic data which is compiled across fps requests
     */
    getCompiledDiagnosticData(): IDiagnosticData;

    /**
     * returns diagnostic data for current request.
     */
    getDiagnosticData(): IDiagnosticData;
}

class DiagnosticDataService extends VssService implements IDiagnosticDataService {
    private compiledDiagnosticData: IDiagnosticData;
    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);

        this.compiledDiagnosticData = this.getDiagnosticData();
    }

    public _serviceRestart(pageContext: IVssPageContext) {
        super._serviceRestart(pageContext);
        const diagnosticData = this.getDiagnosticData();

        if (diagnosticData && diagnosticData.contributions && this.compiledDiagnosticData.contributions) {
            const originalDiagnosticData = diagnosticData.contributions["request"][0];
            for (const contributionId in originalDiagnosticData.contributions) {
                if (!this.compiledDiagnosticData.contributions["request"][0].contributions[contributionId]) {
                    this.compiledDiagnosticData.contributions["request"][0].contributions[contributionId] =
                        originalDiagnosticData.contributions[contributionId];
                }
            }
            for (const contributionId in originalDiagnosticData.relationships) {
                if (!this.compiledDiagnosticData.contributions["request"][0].relationships[contributionId]) {
                    this.compiledDiagnosticData.contributions["request"][0].relationships[contributionId] =
                        originalDiagnosticData.relationships[contributionId];
                } else {
                    for (const relationship of originalDiagnosticData.relationships[contributionId]) {
                        const index = this.compiledDiagnosticData.contributions["request"][0].relationships[contributionId].findIndex(
                            compiledRelationship => {
                                return compiledRelationship.childContributionId === relationship.childContributionId;
                            }
                        );
                        if (index === -1) {
                            this.compiledDiagnosticData.contributions["request"][0].relationships[contributionId].push(relationship);
                        } else if (
                            this.compiledDiagnosticData.contributions["request"][0].relationships[contributionId][index].outputOptions === 0 &&
                            relationship.outputOptions !== 0
                        ) {
                            this.compiledDiagnosticData.contributions["request"][0].relationships[contributionId][index] = relationship;
                        }
                    }
                }
            }
        }
    }

    public getCompiledDiagnosticData(): IDiagnosticData {
        return this.compiledDiagnosticData;
    }

    public getDiagnosticData(): IDiagnosticData {
        const pageDataService = this.pageContext.getService<IVssPageService>("IVssPageService");
        const pageData = pageDataService.getData();
        let diagnosticData: IDiagnosticData = {};

        if (pageData && pageData.diagnostics) {
            diagnosticData = pageData.diagnostics;
        }

        return diagnosticData;
    }
}

Services.add("IDiagnosticDataService", { serviceFactory: DiagnosticDataService, options: ServiceOptions.Persistant });
